// ui-prefs imports LIST_PAGE_SIZE_OPTIONS too; each side only reads the other's exports when called.
import { readRawPref, writeRawPref } from '@/lib/ui-prefs';

export const LIST_PAGE_SIZE_OPTIONS = [20, 50, 100, 1000] as const;

export type ListPageSize = (typeof LIST_PAGE_SIZE_OPTIONS)[number];

const STORAGE_PREFIX = 'list_page_size';

export function isListPageSize(value: number): value is ListPageSize {
  return (LIST_PAGE_SIZE_OPTIONS as readonly number[]).includes(value);
}

export function parseListPageSize(
  raw: string | null | undefined
): ListPageSize | null {
  if (raw == null || raw === '') return null;
  const n = parseInt(raw, 10);
  return Number.isFinite(n) && isListPageSize(n) ? n : null;
}

export function listPageSizeStorageKey(
  listId: string,
  teamId: string | undefined
): string | null {
  return teamId ? `${STORAGE_PREFIX}_${listId}_${teamId}` : null;
}

export function loadListPageSize(storageKey: string | null): ListPageSize | null {
  return parseListPageSize(readRawPref('local', storageKey));
}

/** Full or blocked storage: held for this page until it reloads. */
export function saveListPageSize(
  storageKey: string | null,
  size: ListPageSize
): void {
  writeRawPref('local', storageKey, String(size));
}

/**
 * Sizes for a server-paged table, capped at what its endpoint returns. Never 'all', which
 * would ask for more rows than the server sends.
 */
export function serverPageSizeOptions(maxLimit: number): number[] {
  const sizes = LIST_PAGE_SIZE_OPTIONS.filter((size) => size <= maxLimit);
  return sizes.length > 0 ? sizes : [maxLimit];
}
